import EducationComponent from './Education.vue'
export default EducationComponent
